module.exports = __webpack_public_path__ + "4ad65f82f687cc8f31be67bcd4554281.svg";